import KCard from './Card';

export default class KIcon {
  static Card = KCard;
}
